import React, { useEffect, useRef, useState } from "react";
import "./TicketDetails.css";
import { useParams, useNavigate } from "react-router-dom";

const TicketDetails = () => {
  const containerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const { ticketid } = useParams();
  const navigate = useNavigate();

  const [ticket] = useState({
    ticket_code: "TCK-2026-01045",
    subject: "Payment not received",
    category: "Payment",
    status: "Open",
    created_at: "12 Sep 2024",
  });

  const [messages, setMessages] = useState([
    { id: 1, sender: "User", message: "I made the payment but order is still pending.", time: "10:15 AM" },
    { id: 2, sender: "Support", message: "Please share your transaction ID.", time: "10:30 AM" },
  ]);

  const [reply, setReply] = useState("");

  // Scroll to last message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Dynamic height calculation
  useEffect(() => {
    const updateHeight = () => {
      const headerHeight = document.querySelector(".ticket-header")?.offsetHeight || 0;
      const replyHeight = document.querySelector(".reply-box")?.offsetHeight || 50; // default if not rendered yet
      const backBtnHeight = document.querySelector(".back-btn")?.offsetHeight || 0;

      const totalHeight = window.innerHeight;
      const containerHeight = totalHeight - headerHeight - replyHeight - backBtnHeight - 40; // extra padding buffer

      if (containerRef.current) {
        containerRef.current.style.height = `${containerHeight}px`;
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [ticket.status, reply]);

  const sendReply = () => {
    if (!reply.trim()) return;

    setMessages(prev => [
      ...prev,
      { id: Date.now(), sender: "User", message: reply, time: "Now" },
    ]);
    setReply("");
  };

  return (
    <div className="ticket-details-page">
      <div className="ticket-container">

        <button onClick={() => navigate(-1)} className="back-btn">← Back</button>

        <div className="ticket-header">
          <div>
            <h2>{ticket.ticket_code}</h2>
            <p className="ticket-meta">{ticket.subject} • {ticket.category}</p>
            <p className="ticket-date">Created on {ticket.created_at}</p>
          </div>
          <span className={`ticket-status ${ticket.status.toLowerCase()}`}>{ticket.status}</span>
        </div>

        {/* Conversation with dynamic height */}
        <div ref={containerRef} className="conversation">
          {messages.map(msg => (
            <div key={msg.id} className={`message ${msg.sender === "User" ? "user" : "support"}`}>
              <div className="bubble">
                <p>{msg.message}</p>
                <span className="time">{msg.time}</span>
              </div>
            </div>
          ))}
          <div ref={messagesEndRef}></div>
        </div>

        {ticket.status !== "Closed" ? (
          <div className="reply-box">
            <textarea
              placeholder="Type your reply..."
              value={reply}
              onChange={e => setReply(e.target.value)}
            />
            <button onClick={sendReply}>Send</button>
          </div>
        ) : (
          <div className="ticket-closed">
            This ticket is closed. You can no longer reply.
          </div>
        )}

      </div>
    </div>
  );
};

export default TicketDetails;
